let _apiurl = process.env.VUE_APP_APIURL;
let _wsurl = process.env.VUE_APP_WSURL;
let _appurl = process.env.VUE_APP_APPURL;
let _backofficeurl = process.env.VUE_APP_BACKOFFICEURL;
let _mode = process.env.VUE_APP_APPMODE;
let _project = process.env.VUE_APP_PROJECT;
let _appPrefix = process.env.VUE_APP_PREFIX;

export let awsUrl = "https://s3.eu-central-1.amazonaws.com/files.swisshealthclinics.com/"
export let apiurl = _apiurl;
export let wsurl = _wsurl;
export let appurl = _appurl;
export let backofficeurl = _backofficeurl;
export let mode = _mode;
export let project = _project;
export let appPrefix = _appPrefix;